
const cartMethods = {

    removeOrder: (x, cart) => {
        cart.splice(x, 1);
        cartMethods.saveOrders();  
    },

    addToOrderList: (pump, cart, path, ls) => {
        pump.url = path; 
    
        var allReadyInCart = false
        cart.forEach(item => {
        if (item.idid == pump.idid){
            allReadyInCart = true
            item.order_count++ 
            cartMethods.saveOrders(cart, ls)
            return
        }
        })
    
        if (allReadyInCart) return
    
        pump.order_count = 1
        cart.push(
        pump
        );
        
        cartMethods.saveOrders(cart, ls)
    },

    saveOrders: (cart, ls) => {
        const parsed = JSON.stringify(cart);
        ls.set("cart", parsed, 12 * 60 * 60 * 1000);
        console.log("saved");
    }
}

export default cartMethods
 